<!--
 * @Author: LGY 18588437913@163.com
 * @Date: 2023-02-15 09:53:28
 * @LastEditors: LGY 18588437913@163.com
 * @LastEditTime: 2023-02-28 17:41:39
 * @FilePath: /dz-signup-stupc/src/views/singUp/components/baseInfo.vue.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="page">
    <div class="wrap">
      <div class="card">
        <a-form>
          <!-- 基础信息 -->
          <div class="base-info-box">
            <div class="base-info-item">
              <a-row :gutter="64">
                <template v-for="(item, index) in configItem">
                  <a-col
                    :span="24"
                    v-if="item.blockTitle && item.tab == 'kscj'"
                    class="base-info-title-blank"
                    :class="index == 0 && 'base-info-title-no-blank'"
                  >
                    <div
                      class="base-info-title"
                      :class="index == 0 && 'base-info-title-one'"
                    >
                      {{ item.blockTitle }}
                      <span class="base-info-remind">（{{ desc }}）</span>
                    </div>
                  </a-col>
                  <a-col
                    :span="24"
                    v-if="item.blockTitle && item.tab != 'kscj'"
                    class="base-info-title-blank"
                    :class="index == 0 && 'base-info-title-no-blank'"
                  >
                    <div
                      class="base-info-title"
                      :class="index == 0 && 'base-info-title-one'"
                    >
                      {{ item.blockTitle }}
                      <span class="base-info-remind" v-if="desc && index == 0"
                        >（{{ desc }}）</span
                      >
                    </div>
                  </a-col>
                  <!-- 显示文本 -->
                  <template v-if="item.dataType === '8'">
                    <a-col :span="8" v-if="item.tab === 'img'">
                      <a-form-item
                        :required="item.isNoMust === 1"
                        :label="item.alias ? item.alias : item.itemName"
                      >
                        <a-upload
                          action="/platform/files/publish/file/doupload"
                          accept="image/*"
                          list-type="picture-card"
                          :file-list="item.id"
                          :before-upload="beforeUpload"
                          @preview="handlePreview"
                          @change="selectImage($event, item)"
                          v-if="
                            !disabled &&
                            isOpen == '1' &&
                            item.id.length < 1 &&
                            (item.disable === 'true') == false
                          "
                        >
                          <div>
                            <img class="base-info-icon" :src="addIcon" />
                            <div class="ant-upload-text">点击上传图片</div>
                          </div>
                        </a-upload>
                        <img
                          v-if="
                            disabled || isOpen == '2' || item.disable === 'true'
                          "
                          class="base-info-img"
                          :src="stuImgOrigin + form[item.sign]"
                          alt=""
                        />
                      </a-form-item>
                    </a-col>
                    <a-col :span="8" v-else-if="item.sign === 'postalAddress'">
                      <a-form-item
                        :required="item.isNoMust === 1"
                        :label="item.alias ? item.alias : item.itemName"
                      >
                        <a-input
                          :disabled="
                            disabled || item.disable === 'true' || isOpen == 2
                          "
                          :value="form[item.sign]"
                        />
                      </a-form-item>
                    </a-col>
                    <a-col :span="8" v-else-if="item.sign === 'sBirthday'">
                      <a-form-item
                        :required="item.isNoMust === 1"
                        :label="item.alias ? item.alias : item.itemName"
                      >
                        <a-input
                          :disabled="
                            disabled || item.disable === 'true' || isOpen == 2
                          "
                          :value="form.sBirthday"
                        />
                      </a-form-item>
                    </a-col>
                    <a-col :span="8" v-else-if="item.sign === 'sSex'">
                      <a-form-item
                        :required="item.isNoMust === 1"
                        :label="item.alias ? item.alias : item.itemName"
                      >
                        <a-input
                          :disabled="
                            disabled || item.disable === 'true' || isOpen == 2
                          "
                          :value="
                            form[item.sign] == 1
                              ? '男'
                              : form[item.sign] == 2
                              ? '女'
                              : '未知'
                          "
                        />
                      </a-form-item>
                    </a-col>

                    <a-col
                      :span="8"
                      v-else-if="item.tab === 'dic' && item.sign != 'sSex'"
                    >
                      <a-form-item
                        :required="item.isNoMust === 1"
                        :label="item.alias ? item.alias : item.itemName"
                      >
                        <a-input
                          v-if="dicIndex[item.dicCode] > -1"
                          :disabled="
                            disabled || item.disable === 'true' || isOpen == 2
                          "
                          :value="
                            dicListMap[item.dicCode][dicIndex[item.dicCode]]
                              .name
                          "
                        />
                      </a-form-item>
                    </a-col>
                    <a-col
                      :span="8"
                      v-else-if="item.sign == 'volunteerTwoName'"
                    >
                      <a-form-item
                        :required="item.isNoMust === 1"
                        :label="item.alias ? item.alias : item.itemName"
                      >
                        <div
                          style="
                            position: absolute;
                            top: -53px;
                            left: 60px;
                            font-size: 12px;
                          "
                        >
                          {{ isVolunteerTwoInvalid == "1" ? "（无效）" : "" }}
                        </div>
                        <a-input
                          :disabled="
                            disabled || isOpen == 2 || item.disable === 'true'
                          "
                          :value="form[item.sign] ? form[item.sign] : '-'"
                        />
                      </a-form-item>
                    </a-col>
                    <a-col :span="8" v-else>
                      <a-form-item
                        :required="item.isNoMust === 1"
                        :label="item.alias ? item.alias : item.itemName"
                      >
                        <a-input
                          :disabled="
                            disabled || isOpen == 2 || item.disable === 'true'
                          "
                          :value="form[item.sign] ? form[item.sign] : '-'"
                        />
                      </a-form-item>
                    </a-col>
                  </template>
                  <!-- 输入框 -->
                  <template v-if="item.dataType === '1'">
                    <a-col :span="8">
                      <a-form-item
                        :required="item.isNoMust === 1"
                        :label="item.alias ? item.alias : item.itemName"
                      >
                        <a-input
                          :placeholder="getPlaceholder(item)"
                          v-model="form[item.sign]"
                          :disabled="
                            disabledMap[item.id] ||
                            isOpen == '2' ||
                            item.disable === 'true'
                          "
                        />
                      </a-form-item>
                    </a-col>
                  </template>
                  <!-- 文本框 -->
                  <template v-if="item.dataType === '2'">
                    <a-col :span="24">
                      <a-form-item
                        :required="item.isNoMust === 1"
                        :label="item.alias ? item.alias : item.itemName"
                      >
                        <a-textarea
                          :placeholder="getPlaceholder(item)"
                          v-model="form[item.sign]"
                          :disabled="
                            disabledMap[item.id] ||
                            isOpen == '2' ||
                            item.disable === 'true'
                          "
                          :auto-size="{ minRows: 3, maxRows: 5 }"
                        />
                      </a-form-item>
                    </a-col>
                  </template>
                  <!-- 开关 -->
                  <template v-if="item.dataType === '3'">
                    <template v-if="item.sign === 'isModernPlan'">
                      <a-col
                        :span="8"
                        v-if="oldEmpInfo.volunteerOneMajorType == 1"
                      >
                        <a-form-item
                          :required="item.isNoMust === 1"
                          :label="item.alias ? item.alias : item.itemName"
                        >
                          <a-switch
                            checked-children="是"
                            un-checked-children="否"
                            :disabled="disabledMap[item.id]"
                            @change="isModernPlanSwitchChange($event, item)"
                            v-model="isModernPlanSwitchValue"
                          />
                        </a-form-item>
                      </a-col>
                    </template>
                    <a-col :span="8" v-else>
                      <a-form-item
                        :required="item.isNoMust === 1"
                        :label="item.alias ? item.alias : item.itemName"
                      >
                        <!-- <a-switch
                          :checked="form[item.sign] | switchFilter"
                          checked-children="是"
                          un-checked-children="否"
                          :disabled="
                            disabledMap[item.id] ||
                            isOpen == '2' ||
                            item.disable === 'true'
                          "
                          @change="switchChange($event, item)"
                        /> -->
                        <a-switch
                          v-if="item.sign === 'isTwSoldier'"
                          checked-children="是"
                          un-checked-children="否"
                          :disabled="disabledMap[item.id]"
                          @change="switchChange($event, item)"
                          v-model="isTwSoldierSwitch"
                        />
                        <a-switch
                          v-if="item.sign === 'isBaseFireSafetyMen'"
                          checked-children="是"
                          un-checked-children="否"
                          :disabled="disabledMap[item.id]"
                          @change="
                            isBaseFireSafetyMenSwitchChange($event, item)
                          "
                          v-model="isBaseFireSafetyMenSwitchValue"
                        />
                        <a-switch
                          v-if="item.sign === 'isSportSpecialStu'"
                          checked-children="是"
                          un-checked-children="否"
                          :disabled="disabledMap[item.id]"
                          @change="isSportSpecialStuSwitchChange($event, item)"
                          v-model="isSportSpecialStuSwitchValue"
                        />
                      </a-form-item>
                    </a-col>
                  </template>
                  <!-- 选择框 -->
                  <template v-if="item.dataType === '6'">
                    <template v-if="item.sign === 'cooperateEnter'">
                      <a-col :span="8" v-if="isModernPlanSwitchValue">
                        <a-form-item
                          :required="item.isNoMust === 1"
                          :label="item.alias ? item.alias : item.itemName"
                        >
                          <!-- 合作企业 -->
                          <a-select
                            :id="item.configId"
                            :disabled="
                              disabledMap[item.id] ||
                              isOpen == '2' ||
                              item.disable === 'true'
                            "
                            v-model="cooperateIndex"
                            @change="cooperateChange($event, item)"
                          >
                            <a-select-option :value="-1">
                              请选择
                            </a-select-option>
                            <a-select-option
                              v-for="(val, i) in cooperateList"
                              :value="i"
                              :key="i"
                            >
                              {{ val.enterName }}
                            </a-select-option>
                          </a-select>
                        </a-form-item>
                      </a-col>
                    </template>
                    <a-col :span="8" v-else>
                      <a-form-item
                        :required="item.isNoMust === 1"
                        :label="item.alias ? item.alias : item.itemName"
                      >
                        <a-select
                          v-if="item.dicCode"
                          v-model="dicIndex[item.dicCode]"
                          :disabled="
                            disabledMap[item.id] ||
                            isOpen == '2' ||
                            item.disable === 'true'
                          "
                          @change="dicPickerChange($event, item)"
                        >
                          <a-select-option value="-1"> 请选择 </a-select-option>
                          <a-select-option
                            v-for="(val, i) in dicListMap[item.dicCode]"
                            :value="i"
                            :key="i"
                          >
                            {{ val.name }}
                          </a-select-option>
                        </a-select>
                        <a-date-picker
                          v-if="item.tab == 'date'"
                          v-model="form[item.sign]"
                          class="base-info-w100"
                          :disabled="
                            disabled || isOpen == 2 || item.disable === 'true'
                          "
                          @change="
                            (date, dateString) =>
                              dateChange(date, dateString, item)
                          "
                          format="YYYY-MM-DD"
                        />
                        <a-select
                          v-if="item.sign === 'hjdProvince'"
                          :id="item.configId"
                          v-model="provinceIndex"
                          :disabled="
                            disabledMap[item.id] ||
                            isOpen == '2' ||
                            item.disable === 'true'
                          "
                          @change="provinceChange($event, item)"
                        >
                          <a-select-option :value="-1">
                            请选择
                          </a-select-option>
                          <a-select-option
                            v-for="(val, i) in provinceList"
                            :value="i"
                            :key="i"
                          >
                            {{ val.rSname }}
                          </a-select-option>
                        </a-select>
                        <a-select
                          v-if="item.sign === 'hjdCity'"
                          :id="item.configId"
                          v-model="cityIndex"
                          :disabled="
                            disabledMap[item.id] ||
                            isOpen == '2' ||
                            item.disable === 'true'
                          "
                          @change="cityChange($event, item)"
                        >
                          <a-select-option :value="-1">
                            请选择
                          </a-select-option>
                          <a-select-option
                            v-for="(val, i) in cityList"
                            :value="i"
                            :key="i"
                          >
                            {{ val.rSname }}
                          </a-select-option>
                        </a-select>
                        <a-select
                          v-if="item.sign === 'hjdCounty'"
                          :id="item.configId"
                          v-model="areaIndex"
                          :disabled="
                            disabledMap[item.id] ||
                            isOpen == '2' ||
                            item.disable === 'true'
                          "
                          @change="areaChange($event, item)"
                        >
                          <a-select-option :value="-1">
                            请选择
                          </a-select-option>
                          <a-select-option
                            v-for="(val, i) in areaList"
                            :value="i"
                            :key="i"
                          >
                            {{ val.rSname }}
                          </a-select-option>
                        </a-select>
                        <a-select
                          v-if="item.sign === 'addrProvince'"
                          :id="item.configId"
                          v-model="provinceIndex2"
                          :disabled="
                            disabledMap[item.id] ||
                            isOpen == '2' ||
                            item.disable === 'true'
                          "
                          @change="provinceChange($event, item)"
                        >
                          <a-select-option :value="-1">
                            请选择
                          </a-select-option>
                          <a-select-option
                            v-for="(val, i) in provinceList2"
                            :value="i"
                            :key="i"
                          >
                            {{ val.rSname }}
                          </a-select-option>
                        </a-select>
                        <a-select
                          v-if="item.sign === 'addrCity'"
                          :id="item.configId"
                          v-model="cityIndex2"
                          :disabled="
                            disabledMap[item.id] ||
                            isOpen == '2' ||
                            item.disable === 'true'
                          "
                          @change="cityChange($event, item)"
                        >
                          <a-select-option :value="-1">
                            请选择
                          </a-select-option>
                          <a-select-option
                            v-for="(val, i) in cityList2"
                            :value="i"
                            :key="i"
                          >
                            {{ val.rSname }}
                          </a-select-option>
                        </a-select>
                        <a-select
                          v-if="item.sign === 'addrCounty'"
                          :id="item.configId"
                          :disabled="
                            disabledMap[item.id] ||
                            isOpen == '2' ||
                            item.disable === 'true'
                          "
                          v-model="areaIndex2"
                          @change="areaChange($event, item)"
                        >
                          <a-select-option :value="-1">
                            请选择
                          </a-select-option>
                          <a-select-option
                            v-for="(val, i) in areaList2"
                            :value="i"
                            :key="i"
                          >
                            {{ val.rSname }}
                          </a-select-option>
                        </a-select>
                        <!-- v-if="item.sign === 'recruitmajorproject'" -->
                        <a-select
                          v-if="item.sign === 'mpId'"
                          :id="item.configId"
                          :disabled="
                            disabledMap[item.id] ||
                            isOpen == '2' ||
                            item.disable === 'true'
                          "
                          @change="areaChange($event, item)"
                          v-model="cZyId"
                        >
                          <a-select-option :value="-1">
                            请选择
                          </a-select-option>
                          <a-select-option
                            v-for="val in zyProjectList"
                            :value="val.id"
                            :key="val.id"
                          >
                            {{ val.pname }}
                          </a-select-option>
                        </a-select>
                        <a-select
                          v-if="item.sign === 'mpId2'"
                          :id="item.configId"
                          :disabled="
                            disabledMap[item.id] ||
                            isOpen == '2' ||
                            item.disable === 'true'
                          "
                          @change="areaChange($event, item)"
                          v-model="cZyId2"
                        >
                          <a-select-option :value="-1">
                            请选择
                          </a-select-option>
                          <a-select-option
                            v-for="val in zyProjectList2"
                            :value="val.id"
                            :key="val.id"
                          >
                            {{ val.pname }}
                          </a-select-option>
                        </a-select>
                      </a-form-item>
                    </a-col>
                  </template>
                  <!-- 监护人 -->
                  <template v-if="item.tab === 'jtxx'">
                    <template v-for="(info, idx) in familyInfo">
                      <a-col :span="24">
                        <div class="base-info-subtitle">
                          <div>监护人{{ idx + 1 }}</div>
                          <div
                            class="base-info-delete"
                            @click="delFamily(idx)"
                            :class="{
                              disable: isOpen == '2' || item.disable === 'true',
                            }"
                          >
                            删除
                          </div>
                        </div>
                      </a-col>
                      <a-col :span="8">
                        <a-form-item required label="称谓">
                          <a-select
                            v-model="info.index"
                            @change="relationshipChange($event, info, idx)"
                            :disabled="
                              disabled ||
                              isOpen == '2' ||
                              item.disable === 'true'
                            "
                          >
                            <a-select-option :value="-1"
                              >请选择称谓</a-select-option
                            >
                            <a-select-option
                              v-for="(val, i) in relationshipList"
                              :value="i"
                              :key="i"
                            >
                              {{ val.name }}
                            </a-select-option>
                          </a-select>
                        </a-form-item>
                      </a-col>
                      <a-col :span="8">
                        <a-form-item required label="姓名">
                          <a-input
                            v-model="info.fName"
                            type="text"
                            placeholder="请填写姓名"
                            :disabled="
                              disabled ||
                              isOpen == '2' ||
                              item.disable === 'true'
                            "
                          />
                        </a-form-item>
                      </a-col>
                      <a-col :span="8">
                        <a-form-item required label="年龄">
                          <a-input-number
                            class="base-info-w100"
                            :min="1"
                            :step="1"
                            v-model="info.fAge"
                            placeholder="请填写年龄"
                            :disabled="
                              disabled ||
                              isOpen == '2' ||
                              item.disable === 'true'
                            "
                          />
                        </a-form-item>
                      </a-col>
                      <a-col :span="8">
                        <a-form-item required label="政治面貌">
                          <a-select
                            v-model="info.indexZZ"
                            @change="politicalChange($event, info, idx)"
                            :disabled="
                              disabled ||
                              isOpen == '2' ||
                              item.disable === 'true'
                            "
                          >
                            <a-select-option :value="-1"
                              >请选择政治面貌</a-select-option
                            >
                            <a-select-option
                              v-for="(val, i) in politicalList"
                              :value="i"
                              :key="i"
                            >
                              {{ val.name }}
                            </a-select-option>
                          </a-select>
                        </a-form-item>
                      </a-col>
                      <a-col :span="8">
                        <a-form-item required label="工作单位">
                          <a-input
                            v-model="info.fJobDept"
                            type="text"
                            :disabled="
                              disabled ||
                              isOpen == '2' ||
                              item.disable === 'true'
                            "
                            placeholder="请填写工作单位"
                          />
                        </a-form-item>
                      </a-col>
                      <a-col :span="8">
                        <a-form-item required label="联系电话">
                          <a-input
                            v-model="info.fPhone"
                            class="base-info-w100"
                            :disabled="
                              disabled ||
                              isOpen == '2' ||
                              item.disable === 'true'
                            "
                            :maxLength="11"
                            placeholder="请填写联系电话"
                          />
                        </a-form-item>
                      </a-col>
                    </template>
                    <a-col :span="24">
                      <div class="base-info-w100 base-info-tc">
                        <a-button
                          type="dashed"
                          size="large"
                          style="
                            width: 268px;
                            border-color: #2a79ff;
                            color: #2a79ff;
                          "
                          @click="addFamily(familyInfo)"
                          v-if="familyInfo.length < 2"
                          :disabled="
                            disabled || isOpen == '2' || item.disable === 'true'
                          "
                        >
                          <a-icon type="plus" /> 添加监护人
                        </a-button>
                      </div>
                    </a-col>
                  </template>
                  <!-- 科目 -->
                  <template v-if="item.tab === 'kscj'">
                    <a-col :span="24">
                      <div class="base-info-remind mb20" v-if="item.template">
                        {{ item.template }}
                      </div>
                    </a-col>
                    <template v-for="(info, idx) in subjectInfo">
                      <a-col :span="12">
                        <div class="base-info-subtitle">
                          <div>科目{{ idx + 1 }}</div>
                          <div
                            class="base-info-delete"
                            @click="delSubject(idx)"
                            :class="{
                              disable:
                                disabled ||
                                isOpen == '2' ||
                                item.disable === 'true',
                            }"
                            v-if="idx >= fixedSubjectCount"
                          >
                            删除
                          </div>
                        </div>
                        <a-row :gutter="24">
                          <a-col :span="12">
                            <a-form-item required label="科目">
                              <a-input
                                v-model="info.subject"
                                type="text"
                                placeholder="请填写科目"
                                :disabled="
                                  disabled ||
                                  isOpen == '2' ||
                                  item.disable === 'true' ||
                                  idx < fixedSubjectCount
                                "
                              />
                            </a-form-item>
                          </a-col>
                          <a-col :span="12">
                            <a-form-item required label="考试得分">
                              <!-- <a-input-number
                                v-if="inputFlag == 1"
                                class="base-info-w100"
                                v-model="info.score"
                                :min="0"
                                :step="0.1"
                                placeholder="请填写考试得分"
                                :disabled="
                                  disabled ||
                                  isOpen == '2' ||
                                  item.disable === 'true'
                                "
                              /> -->
                              <a-input
                                class="base-info-w100"
                                v-model="info.score"
                                placeholder="请填写考试得分"
                                :disabled="
                                  disabled ||
                                  isOpen == '2' ||
                                  item.disable === 'true'
                                "
                              />
                            </a-form-item>
                          </a-col>
                        </a-row>
                      </a-col>
                    </template>
                    <a-col :span="24">
                      <div class="base-info-w100 base-info-tc">
                        <a-button
                          type="dashed"
                          size="large"
                          style="
                            width: 268px;
                            border-color: #2a79ff;
                            color: #2a79ff;
                            margin: 0 auto;
                          "
                          v-if="subjectInfo.length < 12"
                          @click="addSubject(subjectInfo)"
                          :disabled="
                            disabled || isOpen == '2' || item.disable === 'true'
                          "
                        >
                          <a-icon type="plus" /> 添加科目
                        </a-button>
                      </div>
                    </a-col>
                  </template>
                  <!-- 附件 -->
                  <template v-if="item.dataType === '7'">
                    <template v-if="item.sign === 'retireCred'">
                      <a-col :span="24" v-if="twFlag">
                        <a-form-item
                          :required="item.isNoMust === 1"
                          :label="item.alias ? item.alias : item.itemName"
                        >
                          <a-upload
                            action="/platform/files/publish/file/doupload"
                            accept="image/*"
                            list-type="picture-card"
                            :file-list="item.id"
                            :before-upload="beforeUpload"
                            @preview="handlePreview"
                            @change="selectImage($event, item)"
                          >
                            <div v-if="isOpen == '1'">
                              <img class="base-info-icon" :src="addIcon" />
                              <div class="ant-upload-text">点击上传图片</div>
                            </div>
                          </a-upload>
                        </a-form-item>
                      </a-col>
                    </template>
                    <template v-else-if="item.sign === 'modernPlanFile'">
                      <a-col :span="24" v-if="isModernPlanSwitchValue">
                        <a-form-item
                          :required="item.isNoMust === 1"
                          :label="item.alias ? item.alias : item.itemName"
                        >
                          <a-upload
                            action="/platform/files/publish/file/doupload"
                            accept="image/*"
                            list-type="picture-card"
                            :file-list="item.id"
                            :before-upload="beforeUpload"
                            @preview="handlePreview"
                            @change="selectImage($event, item)"
                          >
                            <div v-if="isOpen == '1' && item.id.length < 10">
                              <img class="base-info-icon" :src="addIcon" />
                              <div class="ant-upload-text">点击上传图片</div>
                            </div>
                          </a-upload>
                        </a-form-item>
                      </a-col>
                    </template>
                    <template v-else>
                      <a-col :span="24">
                        <a-form-item
                          :required="item.isNoMust === 1"
                          :label="item.alias ? item.alias : item.itemName"
                        >
                          <a-upload
                            action="/platform/files/publish/file/doupload"
                            accept="image/*"
                            list-type="picture-card"
                            :file-list="item.id"
                            :before-upload="beforeUpload"
                          @preview="handlePreview"
                          @change="selectImage($event, item)"
                        >
                          <div
                            v-if="
                              !disabled &&
                              isOpen == '1' &&
                              item.disable !== 'true'
                            "
                          >
                            <img class="base-info-icon" :src="addIcon" />
                            <div class="ant-upload-text">点击上传图片</div>
                          </div>
                        </a-upload>
                        </a-form-item>
                      </a-col>
                    </template>
                  </template>
                </template>
              </a-row>
            </div>
          </div>
          <a-row :gutter="24" style="margintop: 20px">
            <a-col :span="10" :offset="7">
              <a-button
                type="primary"
                size="large"
                @click="save"
                block
                :disabled="disabled || isOpen == '2'"
                class="btn"
              >
                提交
              </a-button>
            </a-col>
          </a-row>
        </a-form>
        <!-- 图片预览 -->
        <a-modal
          :visible="previewVisible"
          :footer="null"
          @cancel="handleCancel"
        >
          <img alt="example" style="width: 100%" :src="previewImage" />
        </a-modal>
      </div>
    </div>
  </div>
</template>

<script>
function getBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });
}
import moment from "moment";
import _ from "lodash";
import { getFlag, saveLog } from "@/api/common";
import {
  getDicAll,
  getCity,
  getStuInfo,
  getTypeCong,
  saveStuInfo,
  getSubjectConfig,
  getStuDetail,
  getCooperaEnterList,
  getCooperaEnter2List,
  getZyprojectListPage,
  queryMajorProject,
  updateInfoType,
} from "@/api/form.js";
import getDate from "@/utils/idcard.js";
import { telValid, emailValid } from "@/utils/reg.js";
import { CompressorImg, ConvertImage } from "@/utils/common.js";
import {
  extractMajorProjectList,
  resolveMpId2SubmitPayload,
  shouldBlockMpId2Submit,
  shouldFallbackMajorProjectRequest,
} from "@/utils/majorProject";
import NextModal from "./nextModal.vue";
export default {
  components: { NextModal },
  props: {
    modalName: String,
    type: [Number, String],
    tFlag: String,
    desc: String,
    tjStatus: [Number, String],
    tjTip: [Number, String],
  },
  data() {
    return {
      OpenTime: "",
      closeTime: "",
      isOpen: "1",
      previewVisible: false,
      previewImage: "",
      item: "",
      disabled: false,
      addIcon: require("@/assets/add-icon.png"),
      stuImgOrigin: this.$store.state.showUrl,
      uvCode: window.localStorage.getItem("uvCode"),
      configItem: [], // 采集项
      switchValue: false, // 开关当前值
      dicListMap: {}, //字段map
      dicIndex: {},
      menuKey: 1,
      tiemMenuKey: 1,
      provinceList: [], // 省--户籍
      cityList: [], // 市
      areaList: [], // 县
      provinceIndex: -1,
      cityIndex: -1,
      areaIndex: -1,
      provinceList2: [], // 省--报考
      cityList2: [], // 市
      areaList2: [], // 县
      provinceIndex2: -1,
      cityIndex2: -1,
      areaIndex2: -1,
      callModelFun: {}, // 验证
      haveDicConfig: [], //有字典的采集项
      // sGsTime: null,
      form: {
        sGsTime: null,
        switch: true,
        postalCode: "",
        addressee: "",
        postalAddress: "",
        contactsphone: "",
        contactsphone2: "",
        sGraduateSchool: "",
        sBirthday: "",
        stuExamList: [],
        stuFamilyList: [],
        isSportSpecialStu: "2",
        isBaseFireSafetyMen: "2",
        isModernPlan: "0",
      },
      oldEmpInfo: {},
      filePathList: [],
      textHeight: {},
      switchKey: 0,
      subjectInfo: [
        {
          subject: "",
          // total: '',
          score: "",
        },
      ], // 科目
      familyIndex: [-1, -1],
      politicalIndex: [-1, -1],
      familyInfo: [
        {
          index: -1,
          indexZZ: -1,
          fName: "",
          fRelationship: "",
          fJobDept: "",
          fPhone: "",
          fAge: "",
          fPolitical: "",
        },
      ], // 科目
      subjectList: [], // 科目字典
      relationshipList: [], // 关系字典
      politicalList: [], // 政治面貌
      typeId: "",
      msg: "", // 提示信息
      disabledMap: {},
      tjStatusVal: "",
      tjTipVal: "",
      fileSizeText: "5M", // 文件大小上限
      subjectMin: "", // 最少科目数
      inputFlag: "", // 输入框类型  1 数字 2字母
      scoreMax: "", // 成绩上限
      cooperateList: [], // 合作企业
      cooperateIndex: -1,
      cooperateName: "",
      twFlag: false, // 退伍军人
      projectZyId: "",
      zyProjectList: [],
      projectZyId2: "",
      zyProjectList2: [],
      configList: [],
      cZyId: "",
      cZyId2: "",
      rPlanId: "",
      hasMpId2Config: false,
      isTwSoldierSwitch: false, // 开关当前值
      isSportSpecialStuSwitchValue: false,
      isBaseFireSafetyMenSwitchValue: false,
      isModernPlanSwitchValue: false,

      stuStatus: "",
      isrequt: "1",
      fixedSubjectCount: 0,
      subjectName: "",
      gradRuleList: [],
      scoreRequiredByGradType: true,
      cooperate1List: [],
      cooperate2List: [],
      isVolunteerTwoInvalid: "", // 1 无效，0 有效
    };
  },
  filters: {
    dateFilter(val) {
      return moment(+val).format("YYYY-MM-DD");
    },
    switchFilter(val) {
      if (val == 1) {
        return true;
      } else {
        return false;
      }
    },
  },
  methods: {
    handleCancel() {
      this.previewVisible = false;
    },
    async handlePreview(file) {
      if (!file.url && !file.preview) {
        file.preview = await getBase64(file.originFileObj);
      }
      this.previewImage = file.url || file.preview;
      this.previewVisible = true;
    },
    // 合作企业
    cooperateChange(e, item) {
      let value = e;
      if (value === -1) {
        value = 0;
      }
      this.cooperateIndex = value;
      this.form[item.sign] = this.cooperateList[value].id;
      this.form[item.textFieldName] = this.cooperateList[value].enterName;
      this.cooperateName = this.cooperateList[value].enterName;
      this.getCooperate2();
    },
    // 判断志愿是否无效
    // 1、当志愿一报考专业的“专业类型”=“现代学徒制”，志愿二的“专业类型”=“普通”，志愿二报考专业标记“无效”。
    // 2、当志愿一报考专业的“专业类型”=“现代学徒制”，志愿二报考专业的“专业类型”=“现代学徒制”，若志愿二报考专业下的合作企业中无志愿一报考专业选择合作企业时，志愿二报考专业标记“无效”。
    // 3、当志愿一报考专业的“专业类型”=“普通”，志愿二报考专业的“专业类型”=“现代学徒制”，志愿二报考专业标记“无效”。
    // 4、当志愿一报考专业的“专业类型”=“普通”，志愿二报考专业的“专业类型”=“普通”，志愿二报考专业无需标记无效
    isInvalid() {
      const v1Type = this.oldEmpInfo.volunteerOneMajorType;
      const v2Type = this.oldEmpInfo.volunteerTwoMajorType;
      if (
        this.isModernPlanSwitchValue &&
        this.oldEmpInfo.volunteerTwoMajorType
      ) {
        // 条件1：志愿1现代学徒制，志愿2普通
        if (v1Type === "1" && v2Type !== "1") {
          this.isVolunteerTwoInvalid = "1";
          return;
        }

        // 条件2：志愿1现代学徒制，志愿2现代学徒制
        if (v1Type === "1" && v2Type === "1") {
          // 条件5：未选择合作企业
          if (!this.cooperateName) {
            this.isVolunteerTwoInvalid = "0";
            return;
          }

          const hasValidEnterprise = this.cooperate2List.some(
            (item) => item.enterName === this.cooperateName
          );
          this.isVolunteerTwoInvalid = hasValidEnterprise ? "0" : "1";
          return;
        }

        // 条件3：志愿1普通，志愿2现代学徒制
        if (v1Type !== "1" && v2Type === "1") {
          this.isVolunteerTwoInvalid = "1";
          return;
        }

        // 条件4：志愿1普通，志愿2普通
        if (v1Type !== "1" && v2Type !== "1") {
          this.isVolunteerTwoInvalid = "0";
          return;
        }
      }

      // 条件3：志愿1普通，志愿2现代学徒制
      if (v1Type !== "1" && v2Type === "1") {
        this.isVolunteerTwoInvalid = "1";
        return;
      }

      // 条件6：未报考现代学徒专项计划
      this.isVolunteerTwoInvalid = "0";
    },
    // 关系
    relationshipChange(e, item, idx) {
      // this.familyIndex[idx] = -1
      // let { value } = e.detail
      let value = e;
      // if (value === -1) {
      //   value = 0
      // }
      Object.assign(this.familyInfo[idx], { index: value });
      this.familyInfo.push();
      item.fRelationship = e + 1;
      // this.familyIndex[idx] = value
      // item.fRelationship = this.relationshipList[this.familyIndex[idx]].value
      // ++this.menuKey
    },
    // 政治面貌
    politicalChange(e, item, idx) {
      // this.politicalIndex[idx] = -1
      // let { value } = e.detail
      let value = e;
      // if (value === -1) {
      //   value = 0
      // }
      // this.politicalIndex[idx] = value
      Object.assign(this.familyInfo[idx], { indexZZ: value });
      this.familyInfo.push();
      item.fPolitical = this.politicalList[e].value;
      // item.fPolitical = this.politicalList[this.politicalIndex[idx]].value
      // ++this.menuKey
    },
    // getDate(val) {
    //   return moment(+val).format('YYYY-MM-DD')
    // },
    // 科目输入验证
    onKeyInput: function (event) {
      const scoreReg = /^[A-D]{1}$|[0-9]$/;
      const scoreWordReg = /^[A-D]{1}$/;
      if (event.target.value) {
        if (this.inputFlag == 1) {
          // 数字
          if (this.scoreMax && event.target.value > this.scoreMax) {
            this.$message.error(`科目成绩不大于${this.scoreMax}分`);
            return;
          }
        } else if (this.inputFlag == 2) {
          // 字母
          if (scoreWordReg.test(event.target.value) == false) {
            this.$message.error("科目成绩为A、B、C、D");
            return;
          }
        } else {
          // 字母 + 数字
          if (scoreReg.test(event.target.value) == false) {
            this.$message.error("科目成绩为A、B、C、D或数字");
            return;
          }
        }
      }
    },
    addSubject(info) {
      if (this.subjectInfo.length < 12) {
        info.push({});
      }
    },
    addFamily(info) {
      if (this.familyInfo.length < 2) {
        info.push({
          index: -1,
          indexZZ: -1,
          fName: "",
          fRelationship: "",
          fJobDept: "",
          fPhone: "",
          fAge: "",
          fPolitical: "",
        });
      }
    },
    delSubject(index) {
      this.subjectInfo.splice(index, 1);
    },
    delFamily(index) {
      this.familyInfo.splice(index, 1);
    },
    // placeholder 提示文字
    getPlaceholder(item) {
      let str = "";
      if (item.dataType === "1") {
        let text = item.alias ? item.alias : item.itemName;
        str = item.template ? item.template : "请输入" + text;
      }
      if (item.dataType === "2") {
        let text = item.alias ? item.alias : item.itemName;
        str = item.template ? item.template : "请输入" + text + "....";
      }
      return str;
    },
    // 文本textarea高度
    gitTextHeight(item, text) {
      this.textHeight[item.sign] = text
        ? Math.ceil(this.form[item.sign].length / 20) * 28 + "px"
        : "28px";
    },
    // 开关选择
    // switchChange(e, item) {
    //   this.switchValue = e;
    //   this.form[item.sign] = "";
    //   if (this.switchValue) {
    //     this.form[item.sign] = 1;
    //     if (item.sign == "isTwSoldier") {
    //       this.twFlag = true;
    //     }
    //   } else {
    //     this.form[item.sign] = 2;
    //     if (item.sign == "isTwSoldier") {
    //       this.twFlag = false;
    //     }
    //   }
    //   // this.switchKey += 1
    // },
    switchChange(e, item) {
      // this.switchValue = e
      // this.form[item.sign] = ''
      if (this.isTwSoldierSwitch) {
        this.form[item.sign] = 1;
        if (item.sign == "isTwSoldier") {
          this.twFlag = true;
        }
      } else {
        this.form[item.sign] = 2;
        if (item.sign == "isTwSoldier") {
          if (this.isBaseFireSafetyMenSwitchValue) {
            this.twFlag = true;
          } else {
            this.twFlag = false;
          }
        }
      }
    },
    isBaseFireSafetyMenSwitchChange(e, item) {
      if (this.isBaseFireSafetyMenSwitchValue) {
        this.twFlag = true;
        this.form[item.sign] = 1;
      } else {
        this.form[item.sign] = 2;
        if (this.isTwSoldierSwitch) {
          this.twFlag = true;
        } else {
          this.twFlag = false;
        }
      }
    },
    isSportSpecialStuSwitchChange(e, item) {
      if (this.isSportSpecialStuSwitchValue) {
        this.form[item.sign] = 1;
      } else {
        this.form[item.sign] = 2;
      }
    },
    isModernPlanSwitchChange(e, item) {
      if (this.isModernPlanSwitchValue) {
        this.form[item.sign] = 1;
      } else {
        this.form[item.sign] = 0;
        this.clearModernPlanRelatedFields();
      }
      this.isInvalid();
    },
    clearModernPlanRelatedFields() {
      // 需求：现代学徒“是->否”时，前端即时清空企业与附件，避免残留值回传
      this.form.cooperateEnter = "";
      this.form.modernPlanFile = "";
      this.cooperateIndex = -1;
      this.cooperateName = "";
      this.configItem.forEach((config) => {
        if (config.sign === "cooperateEnter" && config.textFieldName) {
          this.form[config.textFieldName] = "";
        }
        if (config.sign === "modernPlanFile") {
          config.id = [];
        }
      });
    },

    beforeUpload(file) {
      const isJpgOrPng =
        file.type === "image/jpeg" || file.type === "image/png";
      if (!isJpgOrPng) {
        this.$message.error("请上传jpg或png格式图片!");
      }
      return isJpgOrPng;
    },
    selectImage(info, item) {
      if (info.file.size > 5242880) {
        this.$message.error(`请上传小于${this.fileSizeText}的图片!`);
        return;
      }
      if (info.file.status == "uploading") {
        item.id = info.fileList;
      }
      if (info.file.status == "done") {
        if (this.form[item.sign]) {
          this.form[item.sign] += "," + info.file.response.result.path;
        } else {
          this.form[item.sign] = info.file.response.result.path;
        }
        item.id[item.id.length - 1].url =
          this.stuImgOrigin + info.file.response.result.path;
        this.$message.success("上传成功！");
      }
      if (info.file.status == "removed") {
        item.id = info.fileList;
        this.form[item.sign] = [];
        let arr = [];
        info.fileList.forEach((element) => {
          arr.push(element.url.substr(1));
        });
        this.form[item.sign] = arr.join(",");
      }
    },
    // 日期选择器
    dateChange(date, dateString, item) {
      this.form[item.sign] = moment(dateString);
    },
    // 字典选择
    dicPickerChange(e, item) {
      if (item) {
        // let { value } = e.detail
        let value = e;
        // if (value === '-1') {
        //   value = 0
        // }
        this.dicIndex[item.dicCode] = e;
        if (e >= 0) {
          this.form[item.sign] = this.dicListMap[item.dicCode][value].value;
          this.form[item.textFieldName] =
            this.dicListMap[item.dicCode][value].name;
        } else {
          this.form[item.sign] = "";
          this.form[item.textFieldName] = "";
        }

        // ++this.menuKey
      }
      this.$forceUpdate();
    },
    // 省市县选择
    provinceChange(e, item) {
      // let { value } = e.detail
      let value = e;
      if (value == -1) {
        value = 0;
      }
      if (item.sign == "hjdProvince") {
        this.provinceIndex = value;
        this.cityIndex = -1;
        this.areaIndex = -1;
        this.cityList = this.provinceList[value].item;
        this.areaList = this.cityList[0].item;
      } else if (item.sign == "addrProvince") {
        this.provinceIndex2 = value;
        this.cityIndex2 = -1;
        this.areaIndex2 = -1;
        this.cityList2 = this.provinceList2[value].item;
        this.areaList2 = this.cityList2[0].item;
      }
      this.form[item.sign] = this.provinceList[value].rCode;
      this.form[item.textFieldName] = this.provinceList[value].rSname;
    },
    cityChange(e, item) {
      // let { value } = e.detail
      let value = e;
      if (value === -1) {
        value = 0;
      }
      if (item.sign == "hjdCity") {
        this.cityIndex = value;
        this.areaIndex = -1;
        this.areaList = this.cityList[value].item;
        this.form[item.sign] = this.cityList[value].rCode;
        this.form[item.textFieldName] = this.cityList[value].rSname;
      } else if (item.sign == "addrCity") {
        this.cityIndex2 = value;
        this.areaIndex2 = -1;
        this.areaList2 = this.cityList2[value].item;
        this.form[item.sign] = this.cityList2[value].rCode;
        this.form[item.textFieldName] = this.cityList2[value].rSname;
      }
    },
    areaChange(e, item) {
      // let { value } = e.detail
      let value = e;
      if (value === -1) {
        value = 0;
      }
      if (item.sign == "hjdCounty") {
        this.areaIndex = value;
        this.form[item.sign] = this.areaList[value].rCode;
        this.form[item.textFieldName] = this.areaList[value].rSname;
      } else if (item.sign == "addrCounty") {
        this.areaIndex2 = value;
        this.form[item.sign] = this.areaList2[value].rCode;
        this.form[item.textFieldName] = this.areaList2[value].rSname;
      } else if (item.sign == "mpId") {
        this.cZyId = value;
        this.form[item.sign] = value;
      } else if (item.sign == "mpId2") {
        this.cZyId2 = value;
        this.form[item.sign] = value;
      }
    },
    // 图片压缩
    async compressor(file, item) {
      let _file = file,
        currentFile = file;
      //非jpg格式转jpg
      if (!["image/jpeg", "image/jpg"].includes(file.type)) {
        currentFile = await ConvertImage(file);
      }
      //图片压缩，压缩质量0.5
      CompressorImg(currentFile, 0.4).then((result) => {
        let file = new File([result], currentFile.name, {
          type: currentFile.type,
        });
        const _this = this;
        uni.uploadFile({
          url: "/platform/files/publish/file/doupload",
          file: file,
          name: "file",
          formData: {},
          success: function (res) {
            const { code, msg, result } = JSON.parse(res.data);
            if (code == 0) {
              if (_this.form[item.sign]) {
                _this.form[item.sign] += "," + result.path;
              } else {
                _this.form[item.sign] = result.path;
              }
              _this.filePathList[item.id].push(result.path);
              _this.$forceUpdate();
            }
            this.$message.success(msg);
          },
          fail: function (res) {
            this.$message.error("您选择的照片有误，请按提示上传照片。");
          },
        });
      });
    },
    // 验证必填项
    getVerifTip(item) {
      let str = "";
      if (item.dataType === "1" || item.dataType === "2") {
        let text = item.alias ? item.alias : item.itemName;
        str = "请填写" + text;
      }
      if (item.dataType === "3" || item.dataType === "6") {
        let text = item.alias ? item.alias : item.itemName;
        str = "请选择" + text;
      }
      if (item.dataType === "7") {
        let text = item.alias ? item.alias : item.itemName;
        str = "请上传" + text;
      }
      return str;
    },
    isMpId2Required() {
      const mpId2Config = this.configItem.find((item) => item.sign === "mpId2");
      return !!(mpId2Config && mpId2Config.isNoMust === 1);
    },
    getMpId2VerifTip() {
      const mpId2Config = this.configItem.find((item) => item.sign === "mpId2");
      if (!mpId2Config) {
        return "请选择第二志愿专业项目";
      }
      return this.getVerifTip(mpId2Config);
    },
    // 统一成绩校验口径：
    // 1) 页面存在“考试成绩(kscj)”采集项
    // 2) 该采集项配置为必填(isNoMust=1)
    // 3) 当前毕业类型规则要求成绩(requiredFlag=1)
    // 只有同时满足以上条件，提交时才要求成绩必填
    getScoreValidationMeta() {
      const scoreConfigList = this.configItem.filter(
        (item) => item.tab === "kscj"
      );
      const hasScoreConfig = scoreConfigList.length > 0;
      const requiredByConfig = scoreConfigList.some(
        (item) => Number(item.isNoMust) === 1
      );
      return {
        hasScoreConfig,
        scoreRequired:
          hasScoreConfig &&
          requiredByConfig &&
          this.isScoreRequiredByGradType(),
      };
    },
    submitVerif() {
      return new Promise((resolve, reject) => {
        let result = true;
        const { scoreRequired } = this.getScoreValidationMeta();
        const minSubjectCount = Number(this.subjectMin) || 1;
        // 提交前的基础拦截：按统一口径校验最少科目数
        if (
          !this.twFlag &&
          scoreRequired &&
          this.subjectInfo.length < minSubjectCount
        ) {
          this.$message.warning(`请填写至少${minSubjectCount}项科目成绩`);
          return;
        }
        for (let i = 0; i < this.configItem.length; i++) {
          const item = this.configItem[i];
          if (item.isNoMust === 1 && item.dataType != 8) {
            if (item.tab == "jtxx") {
              if (this.familyInfo.length == 0) {
                this.$message.warning("请填写监护人信息");
                return;
              }
            } else if (!this.form[item.sign] || this.form[item.sign] === "") {
              if (item.sign === "retireCred") {
                if (this.twFlag) {
                  this.$message.warning(this.getVerifTip(item));
                  return;
                }
              } else if (item.sign === "isModernPlan") {
                if (this.isModernPlanSwitchValue) {
                  this.$message.warning(this.getVerifTip(item));
                  result = false;
                  break;
                }
              } else if (item.sign === "cooperateEnter") {
                if (this.isModernPlanSwitchValue) {
                  this.$message.warning(this.getVerifTip(item));
                  result = false;
                  break;
                }
              } else if (item.sign === "modernPlanFile") {
                if (this.isModernPlanSwitchValue) {
                  this.$message.warning(this.getVerifTip(item));
                  result = false;
                  break;
                }
              } else {
                this.$message.warning(this.getVerifTip(item));
                result = false;
                break;
              }
            }
          }
          if (
            this.form[item.sign] &&
            this.form[item.sign] !== "" &&
            item.verification &&
            item.verification != ""
          ) {
            if (!this.callModelFun[item.verification](this.form[item.sign])) {
              this.$message.warning(item.verificationTip);
              result = false;
              break;
            }
          }
        }
        resolve(result);
      });
    },
    // 提交表单内容
    save(e) {
      let time = new Date().getTime();
      if (this.stuStatus == "5") {
        if (time < this.OpenTime) {
          this.$message.info("报名确认时间未开始！");
          return;
        }
        if (time > this.closeTime) {
          this.$message.info("报名确认时间已结束！");
          return;
        }
      }

      this.form.mpId = this.cZyId;
      const mpId2Payload = resolveMpId2SubmitPayload(
        this.hasMpId2Config,
        this.cZyId2
      );
      if (!mpId2Payload.shouldPersist) {
        delete this.form.mpId2;
      } else {
        this.form.mpId2 = mpId2Payload.value;
      }
      this.form.hasMpId2Config = this.hasMpId2Config;
      if (
        shouldBlockMpId2Submit(
          this.hasMpId2Config,
          this.isMpId2Required(),
          this.form.mpId2
        )
      ) {
        this.$message.warning(this.getMpId2VerifTip());
        return;
      }
      this.submitVerif().then((res) => {
        if (!res) {
          return;
        }
        this.form.sStatus = this.tjStatusVal;
        this.form.tFlag = this.tFlag;

        for (let j = 0; j < this.familyInfo.length; j++) {
          if (
            !this.familyInfo[j].fRelationship ||
            this.familyInfo[j].fRelationship == ""
          ) {
            this.$message.warning("请选择称谓");
            return;
          }
          if (!this.familyInfo[j].fName || this.familyInfo[j].fName == "") {
            this.$message.warning("请填写姓名");
            return;
          }
          if (!this.familyInfo[j].fAge || this.familyInfo[j].fAge == "") {
            this.$message.warning("请填写年龄");
            return;
          }
          if (
            !this.familyInfo[j].fPolitical ||
            this.familyInfo[j].fPolitical == ""
          ) {
            this.$message.warning("请选择政治面貌");
            return;
          }
          if (
            !this.familyInfo[j].fJobDept ||
            this.familyInfo[j].fJobDept == ""
          ) {
            this.$message.warning("请填写工作单位");
            return;
          }
          if (!this.familyInfo[j].fPhone || this.familyInfo[j].fPhone == "") {
            this.$message.warning("请填写联系电话");
            return;
          } else {
            if (
              !telValid(
                (this.familyInfo[j].fPhone + "").replace(/^\s+|\s+$/g, "")
              )
            ) {
              this.$message.warning("请填写正确格式的手机号码");
              return;
            }
          }
        }
        if (!this.twFlag) {
          const { hasScoreConfig, scoreRequired } = this.getScoreValidationMeta();
          const minSubjectCount = Number(this.subjectMin) || 1;
          // 二次兜底：save阶段继续沿用同一口径，避免与 submitVerif 规则不一致
          if (scoreRequired && this.subjectInfo.length < minSubjectCount) {
            this.$message.warning(`请填写至少${minSubjectCount}项科目成绩`);
            return;
          }
          // 仅在存在成绩采集项时，才做科目/分数逐项格式校验
          if (hasScoreConfig && this.subjectInfo && this.subjectInfo.length > 0) {
            for (let j = 0; j < this.subjectInfo.length; j++) {
              const subjectVal =
                this.subjectInfo[j].subject === null ||
                this.subjectInfo[j].subject === undefined
                  ? ""
                  : (this.subjectInfo[j].subject + "").trim();
              const scoreVal =
                this.subjectInfo[j].score === null ||
                this.subjectInfo[j].score === undefined
                  ? ""
                  : (this.subjectInfo[j].score + "").trim();
              if (!subjectVal) {
                if (scoreVal) {
                  this.$message.warning("请填写科目");
                  return;
                }
                if (scoreRequired) {
                  this.$message.warning("请填写科目");
                  return;
                }
                continue;
              }
              if (!scoreVal) {
                if (!scoreRequired) {
                  continue;
                }
                if (this.inputFlag == 3) {
                  this.$message.warning("请填写科目考试得分");
                  return;
                } else if (this.inputFlag == 1) {
                  this.$message.warning("请填写科目成绩，类型为数字");
                  return;
                } else if (this.inputFlag == 2) {
                  this.$message.warning(
                    "请填写科目成绩，类型为字母（A、B、C、D）"
                  );
                  return;
                } else {
                  this.$message.warning("请填写科目考试得分");
                  return;
                }
              } else {
                const scoreReg = /^[A-D]{1}$|[0-9]$/;
                const scoreWordReg = /^[A-D]{1}$/;
                if (this.inputFlag == 3) {
                  // 字母 + 数字
                  if (scoreReg.test(scoreVal) == false) {
                    this.$message.warning("科目成绩为A、B、C、D或数字");
                    return;
                  }
                } else if (this.inputFlag == 1) {
                  // 数字
                  if (this.scoreMax && scoreVal > this.scoreMax) {
                    this.$message.warning(`科目成绩不大于${this.scoreMax}分`);
                    return;
                  }
                } else if (this.inputFlag == 2) {
                  // 字母
                  if (scoreWordReg.test(scoreVal) == false) {
                    this.$message.warning("科目成绩为A、B、C、D");
                    return;
                  }
                } else {
                  // 字母 + 数字
                  // if (scoreReg.test(this.subjectInfo[j].score) == false) {
                  //   this.$message.warning("科目成绩为A、B、C、D或数字");
                  //   return;
                  // }
                }
              }
            }
          }
        }

        this.form.planId = this.rPlanId;
        this.form.stuFamilyList = this.familyInfo;
        this.form.stuExamList = this.subjectInfo;
        // 增量标准化：提交前确保 isModernPlan 仅为 0/1
        this.form.isModernPlan = this.isModernPlanSwitchValue ? 1 : 0;
        let dateObject = {};
        for (let item in this.form) {
          if (typeof this.form[item] === "boolean") {
            this.form[item] = this.form[item] * 1;
          }
          for (let i = 0; i < this.configItem.length; i++) {
            if (
              this.configItem[i].sign == item &&
              this.configItem[i].tab == "date" &&
              this.form[item]
            ) {
              Object.assign(dateObject, {
                [item]: _.clone(this.form[item]).valueOf(),
              });
              delete this.form[item];
            }
          }
        }
        let value = {
          isVolunteerTwoInvalid: this.isVolunteerTwoInvalid,
        };

        // return;
        const _this = this;
        this.$confirm({
          title: "提示",
          content: `${_this.tjTipVal}`,
          onOk() {
            saveStuInfo({ ..._this.form, ...dateObject, type: "1", ...value })
              .then((res) => {
                if (res.code == "0") {
                  let userInfo = JSON.parse(localStorage.getItem("user"));
                  let sid = "";
                  if (userInfo) {
                    sid = userInfo.sid;
                  }
                  updateInfoType({
                    sId: sid,
                    typeId: _this.type,
                    status: 1,
                  }).then(() => {
                    _this.$emit("updateInfoType", 1);
                  });
                  // _this.$emit("updateInfoType",1)

                  _this.$message.success(res.msg);
                  _this.queryStuInfo();
                } else {
                  _this.$message.error(res.msg);
                }
              })
              .catch((err) => {})
              .finally(() => {
                // 保存操作记录
                let ids = [];
                let user = JSON.parse(localStorage.getItem("user"));
                ids.push(user.sid.toString());
                let params = { operation: "信息核对提交", stuIds: ids };
                saveLog(params);
              });
          },
          onCancel() {},
        });
      });
    },
    // 回显信息查询
    queryStuInfo() {
      this.oldEmpInfo = {};
      getStuInfo()
        .then((res) => {
          if (res) {
            if (!res["isSportSpecialStu"]) {
              res["isSportSpecialStu"] = "2";
            }
            if (!res["isBaseFireSafetyMen"]) {
              res["isBaseFireSafetyMen"] = "2";
            }

            this.oldEmpInfo = res;
            this.subjectInfo = res.stuExamList;

            if (res.volunteerOneMajorType == "1") {
              if (res.isModernPlan == 1) {
                this.form.isModernPlan = "1";
                this.isModernPlanSwitchValue = true;
              } else {
                this.form.isModernPlan = "0";
                this.isModernPlanSwitchValue = false;
              }
            } else {
              this.form.isModernPlan = "0";
              this.isModernPlanSwitchValue = false;
            }
            if (this.fixedSubjectCount != 0) {
              let arr = [];
              this.subjectInfo.forEach((item) => {
                arr.push(item.subject);
              });

              this.subjectName.split(",").forEach((item) => {
                if (!arr.includes(item)) {
                  this.subjectInfo.unshift({ subject: item });
                }
              });

              let arr1 = [];
              let subjectName = this.subjectName;
              this.subjectInfo.forEach((item) => {
                if (subjectName.includes(item.subject)) {
                  arr1.unshift(item);
                } else {
                  arr1.push(item);
                }
              });

              this.subjectInfo = arr1;
            }

            // this.subjectName.split(",").forEach((item) => {
            //   if (!arr.includes(item)) {
            //     this.subjectInfo.unshift({ subject: item });
            //   }
            // });

            this.stuStatus = res.sStatus;
            // this.sGsTime = moment(res.sGsTime).format('YYYY-MM-DD')
            res.stuFamilyList.forEach((item) => {
              Object.assign(item, {
                index:
                  item.fRelationship * 1 > 0 ? item.fRelationship * 1 - 1 : 0,
                indexZZ: item.fPolitical * 1 > 0 ? item.fPolitical * 1 - 1 : 0,
              });
            });
            this.cZyId = res.mpId;
            this.cZyId2 = res.mpId2;
            this.familyInfo = res.stuFamilyList;
            for (let key in this.form) {
              this.form[key] = res[key];
            }
            this.updateScoreRequiredByGradType();
            if (
              res.sStatus !== 5 &&
              res.sStatus !== 1 &&
              res.sStatus !== 2 &&
              res.sStatus !== 3
            ) {
              this.disabled = true;
            } else {
              this.disabled = false;
            }
            // 审核状态为退回的学生调用是否退回填报开启
            if (res.sStatus == 5) {
              getFlag({
                paramKey: "returnUpdate",
                uvCode: localStorage.getItem("uvCode"),
              }).then((res) => {
                this.isOpen = res.paramValue;
                this.OpenTime = res.opentime;
                this.closeTime = res.closetime;
              });
            }
            if (res.sCard) {
              this.form.sBirthday = moment(getDate(res.sCard)).valueOf();
            }
            if (res.isTwSoldier == 1) {
              // 是退伍军人
              this.twFlag = true;
            }
            if (res.isBaseFireSafetyMen == 1) {
              // 是退伍军人
              this.twFlag = true;
            }
            this.getTypeConfig(
              res.volunteerOne,
              res.volunteerTwo,
              res.stuFamilyList
            );
          }
        })
        .catch((err) => {
          console.log("err");
        });
    },
    fetchMajorProjectList(rPlanId, cZy, volunteerName) {
      if (!rPlanId && !cZy) {
        return Promise.resolve([]);
      }
      const params = {};
      if (rPlanId) {
        params.rPlanId = rPlanId;
      }
      if (cZy) {
        params.cZy = cZy;
      }
      if (volunteerName) {
        params.volunteerName = volunteerName;
      }
      return queryMajorProject(params)
        .then((res) => {
          if (shouldFallbackMajorProjectRequest(res)) {
            return Promise.reject(new Error("invalid major project response"));
          }
          return extractMajorProjectList(res);
        })
        .catch(() => {
          const fallbackParams = {
            page: 1,
            size: 99999,
          };
          if (params.rPlanId) {
            fallbackParams.rPlanId = params.rPlanId;
          }
          if (params.cZy) {
            fallbackParams.cZy = params.cZy;
          }
          if (params.volunteerName) {
            fallbackParams.volunteerName = params.volunteerName;
          }
          return getZyprojectListPage(fallbackParams)
            .then((res) => extractMajorProjectList(res))
            .catch(() => {
              return [];
            });
        });
    },
    getStuDetail(volunteerOne, volunteerTwo) {
      getStuDetail().then((res) => {
        this.rPlanId = res.vPlanId;
        let hasVolunteerOne = false;
        let hasVolunteerTwo = false;
        this.configList.forEach((ele) => {
          if (ele.sign == "volunteerOneName") {
            hasVolunteerOne = true;
          }
          if (ele.sign == "volunteerTwoName") {
            hasVolunteerTwo = true;
          }
        });
        const volunteerOneProjectPromise = hasVolunteerOne
          ? this.fetchMajorProjectList(
              "",
              volunteerOne,
              "volunteerOne"
            ).then((list) => {
              this.zyProjectList = list;
            })
          : this.fetchMajorProjectList(
              this.rPlanId,
              "",
              "volunteerOne"
            ).then((list) => {
              this.zyProjectList = list;
            });
        volunteerOneProjectPromise.then(() => {
          if (!this.cZyId) {
            return;
          }
          let exists = false;
          this.zyProjectList.forEach((project) => {
            if (project.id == this.cZyId) {
              exists = true;
            }
          });
          if (!exists) {
            this.cZyId = "";
            this.form.mpId = "";
          }
        });
        if (this.hasMpId2Config && hasVolunteerTwo && volunteerTwo) {
          this.fetchMajorProjectList("", volunteerTwo, "volunteerTwo").then(
            (list) => {
              this.zyProjectList2 = list;
              if (!this.cZyId2) {
                return;
              }
              let exists = false;
              this.zyProjectList2.forEach((project) => {
                if (project.id == this.cZyId2) {
                  exists = true;
                }
              });
              if (!exists) {
                this.cZyId2 = "";
                this.form.mpId2 = "";
              }
            }
          );
          return;
        }
        this.zyProjectList2 = [];
        this.cZyId2 = "";
        this.form.mpId2 = "";
      });
    },
    // 合作企业
    getCooperate(item) {
      this.cooperateList = [];
      getCooperaEnterList()
        .then((res) => {
          this.cooperateList = res;
          this.cooperate1List = res;
          if (this.form[item.sign]) {
            this.cooperateList.forEach((type, index) => {
              if (type.id + "" === this.form[item.sign] + "") {
                this.cooperateIndex = index;
              }
            });
          }

          const selected = this.cooperateList.find(
            (item) => this.oldEmpInfo.cooperateEnter == item.id
          );
          this.cooperateName = selected ? selected.enterName : "";

          this.isInvalid();
        })
        .catch((err) => {
          console.log("err");
        });
    },
    // 志愿二合作企业
    getCooperate2(item) {
      this.cooperate2List = [];
      let userInfo = JSON.parse(localStorage.getItem("user"));
      let sid = "";
      if (userInfo) {
        sid = userInfo.sid;
      }
      getCooperaEnter2List({ sId: sid })
        .then((res) => {
          this.cooperate2List = res;

          this.isInvalid();
        })
        .catch((err) => {
          console.log("err");
        });
    },
    // 获取采集项配置
    getTypeConfig(volunteerOne, volunteerTwo, stuFamilyList) {
      this.configItem = [];
      this.hasMpId2Config = false;
      getTypeCong({ typeId: this.typeId })
        .then((res) => {
          this.configItem = [];
          const flag = []; // 判断是否处理过
          this.configList = res;
          res.forEach((item) => {
            if (item.block && flag.indexOf(item.block) === -1) {
              res.forEach((value, index) => {
                if (item.block == value.block) {
                  if (flag.indexOf(item.block) === -1) {
                    value.blockTitle = item.block;
                    flag.push(item.block);
                    if (
                      this.configItem[this.configItem.length - 1] &&
                      this.configItem[this.configItem.length - 1].blockEnd
                    ) {
                      this.configItem[
                        this.configItem.length - 1
                      ].blockEnd = false;
                    }
                  }
                  this.configItem.push(value);
                }
              });
              this.configItem[this.configItem.length - 1].blockEnd = true;
            } else if (!item.block) {
              this.configItem.push(item);
            }
          });
          const dicCodeList = [];
          let isNoCity = false;
          let isNoSubject = false;
          this.haveDicConfig = [];
          this.dicIndex = {};
          res.forEach((item) => {
            if (item.sign) {
              this.form[item.sign] = this.oldEmpInfo[item.sign];
              if (item.sign == "mpId2") {
                this.hasMpId2Config = true;
              }
              if ("true" == item.disable && this.oldEmpInfo[item.sign]) {
                this.disabledMap[item.id] = true;
              } else {
                this.disabledMap[item.id] = this.disabled;
              }
              if (item.tab == "file" || item.sign == "sPhoto") {
                let oldfilelist = this.oldEmpInfo[item.sign]
                  ? this.oldEmpInfo[item.sign].split(",")
                  : [];
                let newfilelist = [];
                for (let i = 0; i < oldfilelist.length; i++) {
                  const obj = {
                    url: this.stuImgOrigin + oldfilelist[i],
                    uid: i,
                    status: "done",
                    name: `a${i}.jpg`,
                  };
                  newfilelist.push(obj);
                }
                item.id = newfilelist;
              } else if (item.tab == "date") {
                if (this.form[item.sign] > 0) {
                  this.form[item.sign] = moment(this.form[item.sign]).format(
                    "YYYY-MM-DD"
                  );
                } else {
                  this.form[item.sign] = null;
                }
              }
            }
            if (item.dataType === "3") {
              this.form[item.sign] == !!this.form[item.sign];

              if (this.form.isTwSoldier == "2") {
                this.isTwSoldierSwitch = false;
              } else {
                this.isTwSoldierSwitch = true;
              }
              if (this.form.isSportSpecialStu == "2") {
                this.isSportSpecialStuSwitchValue = false;
              } else {
                this.isSportSpecialStuSwitchValue = true;
              }
              if (this.form.isBaseFireSafetyMen == "2") {
                this.isBaseFireSafetyMenSwitchValue = false;
              } else {
                this.isBaseFireSafetyMenSwitchValue = true;
              }
            }

            if (
              item.sign == "isModernPlan" &&
              this.oldEmpInfo.volunteerOneMajorType == "1"
            ) {
              // this.form.isModernPlan = 1;
              // this.isModernPlan = 1;
              // this.isModernPlanSwitchValue = true;
            }

            if (item.textFieldName) {
              this.form[item.textFieldName] =
                this.oldEmpInfo[item.textFieldName];
            }
            if (item.dicCode) {
              dicCodeList.push(item.dicCode);
              dicCodeList.push("61012"); // 关系（父亲，母亲）
              dicCodeList.push("61015");
              this.dicIndex[item.dicCode] = "-1";
              this.haveDicConfig.push(item);
            }
            // 合作企业
            if (item.tab === "cooperateEnter") {
              this.getCooperate(item);
              this.getCooperate2();
            }
            if (
              item.tab === "province" ||
              item.tab === "city" ||
              item.tab === "county"
            ) {
              isNoCity = true;
            }
            if (item.tab === "kscj") {
              this.isrequt = item.isNoMust;
              // 考试成绩
              isNoSubject = true;
            }
          });
          this.getAllDic(dicCodeList);
          if (isNoCity) {
            this.getCityList();
          }
          if (isNoSubject) {
            this.getSubjectConfig();
          }
          if (!this.hasMpId2Config) {
            this.cZyId2 = "";
            this.zyProjectList2 = [];
            delete this.form.mpId2;
          }
          this.getStuDetail(volunteerOne, volunteerTwo);
        })
        .catch((err) => {});
    },
    //获取省市县
    getCityList() {
      const _this = this;
      this.provinceList = [];
      this.provinceList2 = [];
      Promise.all([getCity()]).then((res) => {
        if (res) {
          res[0].forEach((element) => {
            _this.provinceList.push(element);
            _this.provinceList2.push(element);
          });
          // 户籍所在地
          if (this.form.hjdProvince) {
            this.provinceList.forEach((p, idx) => {
              if (p.rCode == this.form.hjdProvince) {
                this.provinceIndex = idx;
                this.cityList = this.provinceList[this.provinceIndex].item;
              }
            });
          }
          if (this.form.hjdCity) {
            this.cityList.forEach((p, idx) => {
              if (p.rCode == this.form.hjdCity) {
                this.cityIndex = idx;
                this.areaList = this.cityList[this.cityIndex].item;
              }
            });
          }
          if (this.form.hjdCounty) {
            this.areaList.forEach((p, idx) => {
              if (p.rCode == this.form.hjdCounty) {
                this.areaIndex = idx;
              }
            });
          }
          // 报考地
          if (this.form.addrProvince) {
            this.provinceList2.forEach((p, idx) => {
              if (p.rCode == this.form.addrProvince) {
                this.provinceIndex2 = idx;
                this.cityList2 = this.provinceList2[this.provinceIndex2].item;
              }
            });
          }
          if (this.form.addrCity) {
            this.cityList2.forEach((p, idx) => {
              if (p.rCode == this.form.addrCity) {
                this.cityIndex2 = idx;
                this.areaList2 = this.cityList2[this.cityIndex2].item;
              }
            });
          }
          if (this.form.addrCounty) {
            this.areaList2.forEach((p, idx) => {
              if (p.rCode == this.form.addrCounty) {
                this.areaIndex2 = idx;
              }
            });
          }
        }
      });
    },
    setDicInfo() {
      this.familyInfo.forEach((item, idx) => {
        this.relationshipList.forEach((dic, didex) => {
          if (dic.value == item.fRelationship) {
            this.familyIndex[idx] = didex;
          }
        });
        this.politicalList.forEach((dic, didex) => {
          if (dic.value == item.fPolitical) {
            this.politicalIndex[idx] = didex;
          }
        });
      });
    },
    // 获取字典
    getAllDic(codes) {
      this.dicListMap = {};
      const _this = this;
      getDicAll({
        uvcode: this.uvCode,
        types: codes.join(","),
      }).then((res) => {
        if (res) {
          let dicListMapTemp = {};
          res.forEach((item) => {
            // _this.dicListMapTemp[item.code] = [];
            dicListMapTemp[item.code] = item.dicts;
            // _this.dicListMap[item.code] = [];
            // _this.dicListMap[item.code] = item.dicts;
          });
          _this.dicListMap = dicListMapTemp;
          _this.haveDicConfig.forEach((item) => {
            const dic = _this.dicListMap[item.dicCode];
            if (dic) {
              for (let i = 0; i < dic.length; i++) {
                if (dic[i].value === _this.form[item.sign]) {
                  _this.dicIndex[item.dicCode] = i;
                  break;
                }
              }
            }
          });
        }
        res.filter((item) => {
          // 科目
          if (item.code === 61037) {
            _this.subjectList = item.dicts;
          }
          // 关系
          if (item.code === 61012) {
            _this.relationshipList = item.dicts;
          }
          // 政治面貌
          if (item.code === 61015) {
            _this.politicalList = item.dicts;
          }
          _this.setDicInfo();
        });
      });
    },
    // 获取科目、成绩输入配置
    getSubjectConfig() {
      getSubjectConfig()
        .then((res) => {
          // this.subjectMin = res.collectSize;
          // this.inputFlag = res.subjectScoreType;
          // this.scoreMax = res.numScoreValid;
          // this.fixedSubjectCount = res.fixedSubjectCount;
          // this.subjectName = res.subjectName;
          this.formatSubjectConfig(res);
        })
        .catch((err) => {
          this.formatSubjectConfig({});
        });
    },
    formatSubjectConfig(config) {
      this.subjectMin = config.collectSize ?? 1;
      this.inputFlag = config.subjectScoreType ?? 1;
      this.scoreMax = config.numScoreValid ?? 100;
      this.fixedSubjectCount = config.fixedSubjectCount || 0;
      this.subjectName = config.subjectName || "";
      this.gradRuleList = config.gradRuleList || [];
      this.updateScoreRequiredByGradType();
    },
    getCurrentGradTypeCode() {
      if (this.form.kbylb || this.form.kbylb === 0) {
        return (this.form.kbylb + "").trim();
      }
      if (this.oldEmpInfo.kbylb || this.oldEmpInfo.kbylb === 0) {
        return (this.oldEmpInfo.kbylb + "").trim();
      }
      return "";
    },
    updateScoreRequiredByGradType() {
      const gradTypeCode = this.getCurrentGradTypeCode();
      if (!gradTypeCode || !this.gradRuleList || this.gradRuleList.length === 0) {
        this.scoreRequiredByGradType = true;
        return;
      }
      const gradRule = this.gradRuleList.find(
        (item) => (item.gradTypeCode + "").trim() === gradTypeCode
      );
      if (!gradRule) {
        this.scoreRequiredByGradType = true;
        return;
      }
      this.scoreRequiredByGradType = Number(gradRule.requiredFlag) === 1;
    },
    isScoreRequiredByGradType() {
      this.updateScoreRequiredByGradType();
      return this.scoreRequiredByGradType;
    },
  },
  watch: {
    "form.kbylb"() {
      this.updateScoreRequiredByGradType();
    },
  },
  created() {
    // let option = this.$route.query
    let option = {
      type: this.type,
      desc: this.desc,
      tjStatus: this.tjStatus,
      tjTip: this.tjTip,
    };
    this.typeId = option.type;
    if (option.msg && option.msg !== "undefined") {
      this.msg = option.msg;
    }

    if (option.tjStatus && option.tjStatus !== "undefined") {
      this.tjStatusVal = option.tjStatus;
    } else {
      // this.tjStatusVal = 2;

      this.tjStatusVal = this.$route.query.tjStatus;
    }

    if (option.tjTip && option.tjTip !== "undefined") {
      this.tjTipVal = option.tjTip;
    } else {
      this.tjTipVal =
        "确认提交吗？信息确认无误后，请进行证明材料回传，未进行证明材料回传不予审核通过！";
    }
  },
  mounted() {
    this.getSubjectConfig();
    this.queryStuInfo();

    this.callModelFun.companyCodeValid = function (val) {
      return /[0-9A-HJ-NPQRTUWXY]{2}\d{6}[0-9A-HJ-NPQRTUWXY]{10}/.test(val);
    };
    this.callModelFun.lxfsValid = function (val) {
      if (/^0\d{2,3}-?\d{7,8}$/.test(val) || /^1[3456789]\d{9}$/.test(val)) {
        return true;
      } else {
        return false;
      }
    };
    this.callModelFun.yzbmValid = function (val) {
      if (/^\d{6}$/.test(val)) {
        return true;
      } else {
        return false;
      }
    };
    this.callModelFun.qxxValid = function (val) {
      if (/^(?:[1-9])(?:[0-9]*)00$/.test(val) || val >= 1500) {
        return true;
      } else {
        return false;
      }
    };
  },
};
</script>

<style lang="less" scoped>
@import "../../../styles/baseInfo.less";
.disable {
  pointer-events: none;
}
</style>
